import type { PaymentProduct } from '../api/checkout';

// Helper to build auth URLs with redirectTo param
export const buildAuthUrl = (authPath: '/login' | '/register', redirectTo: string): string => {
  return `${authPath}?redirectTo=${encodeURIComponent(redirectTo)}`;
};

// Feature bullet points for credit packs
export const creditPackFeatures = [
  'Create boards for any sport',
  'Unlimited participants',
  'Never expires',
  'All features included',
];

// Format price from cents to dollars
export const formatPrice = (cents: number): string => {
  return `$${(cents / 100).toFixed(2)}`;
};

// Calculate per-board price
export const calculatePerBoardPrice = (cents: number, credits: number): string => {
  return `$${(cents / 100 / credits).toFixed(2)}/board`;
};

// Determine if this is the "best value" pack (lowest cost per board)
export const isBestValue = (product: PaymentProduct, allProducts: PaymentProduct[]): boolean => {
  if (allProducts.length <= 1) return false;

  const productsWithCostPerBoard = allProducts.map(p => {
    const credits = p.metadata?.boardCredits || 1;
    const price = p.prices?.[0]?.amount || 0;
    return {
      id: p.id,
      costPerBoard: price / credits
    };
  });

  const bestValueProduct = productsWithCostPerBoard.reduce((best, current) =>
    current.costPerBoard < best.costPerBoard ? current : best
  );

  return product.id === bestValueProduct.id;
};
